
import './App.css';
import Project from './Component/Project1/Project';

function App() {
  return (
    <div className="App">
      <Project />
    </div>
  );
}

export default App;
